module.exports = __webpack_public_path__ + "img/logo2.0b3ecb0a.png";